import React from "react";

const List = (props: Api.AnyItem): JSX.Element => <ul>{props.children}</ul>;

export default List;
